import { render, staticRenderFns } from "./moduleConfig.vue?vue&type=template&id=fe577590&scoped=true&"
import script from "./moduleConfig.vue?vue&type=script&lang=js&"
export * from "./moduleConfig.vue?vue&type=script&lang=js&"
import style0 from "./moduleConfig.vue?vue&type=style&index=0&id=fe577590&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe577590",
  null
  
)

export default component.exports